// spreadsheet url: https://docs.google.com/spreadsheets/d/1dqrpoEJHafq1q2pbxfa-8vQa_IJQKpbqmMmKD7GQSxw/edit?usp=sharing
export const FEEDBACK_TASKS_URL = __STAGING__
  ? 'https://script.google.com/a/gangverk.is/macros/s/AKfycby-5wtVH7iAdFMTptLWn0P_e1twi_VsWkUPQgt3Ww/exec'
  : 'https://script.google.com/a/gangverk.is/macros/s/AKfycbwmnmi1RJUBX16n_U5pP3GBSsguUW7vrfHvaEMxlA/exec';

// spreadsheet url: https://docs.google.com/spreadsheets/d/1zfI3Qm0EnnXwuYKja2clOmzDwwlKjvdaEpO0tyd2c3w/edit?usp=sharing
export const FEEDBACK_REPORTS_URL = __STAGING__
  ? 'https://script.google.com/a/gangverk.is/macros/s/AKfycbxa7HgeCowTWMhKqjnoHMHbe7ZHhYOIn3cBnywl/exec'
  : 'https://script.google.com/a/gangverk.is/macros/s/AKfycbxJ8miwawFd17J_9lHosehxAjwhCEcIjTt_u-ry/exec';

export default {
  tasks: FEEDBACK_TASKS_URL,
  reports: FEEDBACK_REPORTS_URL,
};
